import React, { Fragment, PureComponent } from 'react';
// eslint-disable-next-line no-unused-vars
import PropTypes, { array, elementType } from 'prop-types';

import {Input, Select} from '../index.js';

const ownControlsType = [Input, Select];

export default class Form extends PureComponent {
	constructor(props) {
		super(props);
		this.submit = this.submit.bind(this);
	}

	ownItems = [];

	submit(event, params) {

		if (event) event.preventDefault();

		let errorItems = [];
		let result = true;
		if (this.props.onSubmit)
			result = this.props.onSubmit();

		//validate
		this.ownItems.forEach((element) => {

			if (element.ref && element.ref.current && element.ref.current.validate) {
				let val = element.ref.current.validate() || false;
				if (!val) result = val;

				if (!val) {
					errorItems.push(element.ref.current);
				}
			}
		});

		if (result && this.props.onValidSubmit) this.props.onValidSubmit(params);

		return result;
	}

	reset() { }

	cloneElement(element, key) {

		if (!element) {
			return null;
		}

		//si es un arreglo
		if (Array.isArray(element))
			return element.map((x) => {
				return this.cloneElement(x);
			});
		//si es un elemento string lo retornamos
		// if (!element || typeof (element) === "string" || typeof (element.type) == "string" || !element.props)
		if (element && ['a', 'p', 'li', 'button', 'hr', 'ul'].includes(element.type)) return element;


		if (element?.type && ownControlsType.includes(element.type)) {
			let elementCloned = React.cloneElement(element, {
				key: key,
				ref: React.createRef(),
			});

			this.ownItems.push(elementCloned);

			return elementCloned;
		}

		if (element.props && element.props.children) {
			if (Array.isArray(element.props.children)) {

				return React.cloneElement(element, {
					key: key,
					children: element.props.children.map((x, key) => {
						return this.cloneElement(x, key);
					}),
				});

			} else {
				return React.cloneElement(element, {
					key: key,
					children: this.cloneElement(element.props.children),
				});
			}
		} else return element;
	}

	render() {
		this.ownItems = [];
		let childs = React.Children.map(this.props.children, (child) => {
			return this.cloneElement(child);
		});

		return this.props.noSubmit ? (
			<Fragment>{childs}</Fragment>
		) : (
				<form onSubmit={this.submit} id={this.props.id} className="p-0 m-0" noValidate={this.props?.noValidate}>
					{<input type="submit" style={{ display: 'none' }} />}

					{childs}
				</form>
			);
	}
}
